import { UX_BOLGEN_2026_09 } from "./content/2026-09-29-ux-bolgen";
import { DOKUMENTARKIV_2026_09 } from "./content/2026-09-30-dokumentarkiv";
import { SLIDE_PREVIEW_2026_09 } from "./content/2026-09-30-slide-preview";
import { TILGANGSFIKSER_2026_10 } from "./content/2026-10-01-tilgangsfikser";
import { SKJERMROLLE_2026_10 } from "./content/2026-10-01-skjermrolle";
import { SMOKE_FIKSER_2026_10 } from "./content/2026-10-01-smoke-fikser";
import { RAPPORTFEIL_2026_10 } from "./content/2026-10-01-rapportfeil";
import { DOKUMENTEDITOR_2026_10 } from "./content/2026-10-02-dokumenteditor";
import { EIERSKAP_2026_10 } from "./content/2026-10-02-eierskap";
import { GRUPPER_2026_10 } from "./content/2026-10-02-grupper";
import { HJELP_SOK_2026_10 } from "./content/2026-10-02-hjelp-sok";
import { DOKUMENTARKIV_TRE_2026_10 } from "./content/2026-10-02-dokumentarkiv-tre";
import { BILDER_OG_VIDEO_2026_10 } from "./content/2026-10-02-bilder-og-video";
import { TIMEBANK_SALDO_2026_10 } from "./content/2026-10-05-timebank-saldo";
import { FULL_BREDDE_2026_10 } from "./content/2026-10-05-full-bredde";
import { HJELP_SKALL_2026_10 } from "./content/2026-10-05-hjelp-skall";
import { VERKTOYLINJE_2026_10 } from "./content/2026-10-05-verktoylinje";
import { RBAC_REDIRECT_2026_10 } from "./content/2026-10-05-rbac-redirect";
import { DOKUMENTEDITOR_LEXICAL_2026_10 } from "./content/2026-10-05-dokumenteditor-lexical";
import { CHUNK_FEIL_2026_10 } from "./content/2026-10-06-chunk-feil";
import { MARKOR_2026_10 } from "./content/2026-10-06-markor";
import { DOKUMENTEDITOR_ARK_2026_10 } from "./content/2026-10-06-dokumenteditor-ark";
import { DOKUMENTVERSJONER_2026_10 } from "./content/2026-10-06-dokumentversjoner";
import { UTRULLINGER_2026_10 } from "./content/2026-10-07-utrullinger";
import { VERSJONSVARSEL_2026_10 } from "./content/2026-10-07-versjonsvarsel";
import { POWEROFFICE_KOBLING_2026_10 } from "./content/2026-10-07-poweroffice-kobling";
import { MELLOMFAKTURA_2026_10 } from "./content/2026-10-07-mellomfaktura";
import { UTRULLING_LESBARHET_2026_10 } from "./content/2026-10-07-utrulling-lesbarhet";
import { BILDESTORRELSE_2026_10 } from "./content/2026-10-08-bildestorrelse";
import { CRM_KUNDEKORT_2026_10 } from "./content/2026-10-17-crm-kundekort";
import { CRM_FASE_2_SALGSMULIGHETER_2026_10 } from "./content/2026-10-17-crm-fase-2-salgsmuligheter";
import { CRM_SIGNALER_2026_10 } from "./content/2026-10-17-crm-signaler";
import { CRM_FASE_4_LEADS_OG_MOTER_2026_10 } from "./content/2026-10-17-crm-fase-4-leads-og-moter";
import { TILBUD_TIMEPRIS_2026_10 } from "./content/2026-10-12-tilbud-timepris";
import { BUDSJETT_REKKEFOLGE_2026_10 } from "./content/2026-10-12-budsjett-rekkefolge";
import { DOKUMENTER_DRA_OG_SLIPP_2026_10 } from "./content/2026-10-12-dokumenter-dra-og-slipp";
import { PROGNOSE_GRUNNLAG_2026_10 } from "./content/2026-10-12-prognose-grunnlag";
import { KUNDEKORT_WIREFRAME_2026_10 } from "./content/2026-10-19-kundekort-wireframe";
import { KUNDEKORT_V3_2026_10 } from "./content/2026-10-19-kundekort-v3";
import { KUNDELISTE_V2_2026_10 } from "./content/2026-10-20-kundeliste-v2";
import { FAKTURA_SENDING_2026_10 } from "./content/2026-10-23-faktura-sending";
import { KONVERTERING_EST_KOSTNAD_2026_10 } from "./content/2026-10-23-konvertering-est-kostnad";
import { BILAGSFORDELING_TILGANG_2026_10 } from "./content/2026-10-24-bilagsfordeling-tilgang";
import { TM_BILAGSSTATUS_2026_10 } from "./content/2026-10-24-tm-bilagsstatus";
import { BILAG_LINJE_FRA_GODKJENNING_2026_10 } from "./content/2026-10-24-bilag-linje-fra-godkjenning";
import { FAKTURA_BETALINGSDATO_2026_10 } from "./content/2026-10-26-faktura-betalingsdato";
import { KREDITERT_FAKTURA_2026_10 } from "./content/2026-10-26-kreditert-faktura";
import { LEAD_POOL_2026_10 } from "./content/2026-10-27-lead-pool";
import { FAKTURAOVERSIKT_2026_10 } from "./content/2026-10-26-fakturaoversikt";
import { TAGGING_I_SVAR_2026_10 } from "./content/2026-10-23-tagging-i-svar";
import { NY_KUNDE_2026_10 } from "./content/2026-10-23-ny-kunde";
import { UTSTYRSREGISTER_2026_10 } from "./content/2026-10-24-utstyrsregister";
import { FRILANSERBANKEN_2026_10 } from "./content/2026-10-24-frilanserbanken";
import { BILAG_LEVERANDOR_2026_10 } from "./content/2026-10-24-bilag-leverandor";
import { FRILANS_PA_PROSJEKT_2026_10 } from "./content/2026-10-24-frilans-pa-prosjekt";
import { UTSTYRSBOOKING_2026_10 } from "./content/2026-10-24-utstyrsbooking";
import { UTSTYR_PRODUKTDATA_2026_10 } from "./content/2026-10-24-utstyr-produktdata";
import { UTSTYR_BELEGG_2026_10 } from "./content/2026-10-25-utstyr-belegg";
import { KUNDELOGOER_2026_10 } from "./content/2026-10-25-kundelogoer";
import { ENDRE_KUNDELOGO_2026_10 } from "./content/2026-10-25-endre-kundelogo";
import { KUNDEKORT_GEEK_KRONER_2026_10 } from "./content/2026-10-25-kundekort-geek-kroner";
import { UTSTYR_SERVICE_2026_10 } from "./content/2026-10-25-utstyr-service";
import { FRILANSERKORT_V2_2026_10 } from "./content/2026-10-25-frilanserkort-v2";
import { LOKASJONSBANK_2026_10 } from "./content/2026-10-25-lokasjonsbank";
import { NETTSIDE_NY_KUNDE_2026_10 } from "./content/2026-10-25-nettside-ny-kunde";
import { LOKASJONER_KART_OG_SOL_2026_10 } from "./content/2026-10-25-lokasjoner-kart-og-sol";
import { ALLE_KAN_OPPRETTE_KUNDE_2026_10 } from "./content/2026-10-25-alle-kan-opprette-kunde";
import { LOKASJONER_PA_PROSJEKTER_2026_10 } from "./content/2026-10-25-lokasjoner-pa-prosjekter";
import { LOKASJONER_ROTER_BILDER_2026_10 } from "./content/2026-10-25-lokasjoner-roter-bilder";
import { TILGANG_FRAVAER_OG_DISPLAY_2026_10 } from "./content/2026-10-25-tilgang-fravaer-og-display";
import { LOKASJONER_FRA_MOBIL_2026_10 } from "./content/2026-10-25-lokasjoner-fra-mobil";
import { ALLE_KAN_ENDRE_KUNDE_2026_10 } from "./content/2026-10-26-alle-kan-endre-kunde";
import { INNLOGGING_HJELP_2026_10 } from "./content/2026-10-26-innlogging-hjelp";
import { FAERRE_OPPDATERINGSVARSLER_2026_10 } from "./content/2026-10-26-faerre-oppdateringsvarsler";
import { TILBUDSARBEIDSROM_GRUNNLAG_2026_10 } from "./content/2026-10-27-tilbudsarbeidsrom-grunnlag";
import { TILBUDSARBEIDSROM_IDE_2026_10 } from "./content/2026-10-27-tilbudsarbeidsrom-ide";
import { FUNKSJONSBRYTERE_RYDDET_2026_10 } from "./content/2026-10-27-funksjonsbrytere-ryddet";
import { INTERNPROSJEKTER_OPPGAVER_2026_10 } from "./content/2026-10-27-internprosjekter-oppgaver";
import { MANGLENDE_TIMER_VARSEL_2026_10 } from "./content/2026-10-27-manglende-timer-varsel";
import type { ChangelogEntry } from "./types";
import { SIGNALER_DUBLETTER_2026_10 } from "./content/2026-10-25-signaler-dubletter";
import { SIGNALKORT_V2_2026_10 } from "./content/2026-10-27-signalkort-v2";
import { SIGNALER_LAERER_2026_10 } from "./content/2026-10-27-signaler-laerer";
import { OPPDAG_RYDDET_2026_10 } from "./content/2026-10-27-oppdag-ryddet";
import { LEAD_KONTAKTER_2026_10 } from "./content/2026-10-28-lead-kontakter";
import { LEADLISTER_NYTT_LEAD_2026_10 } from "./content/2026-10-28-leadlister-og-nytt-lead";
import { MALTALL_OPPRYDDING_2026_10 } from "./content/2026-10-27-maltall-opprydding";
import { MALTALL_OPPFOLGING_2026_10 } from "./content/2026-10-28-maltall-oppfolging";
import { CHAT_ROM_2026_10 } from "./content/2026-10-28-chat-rom";
import { BOOK_MOTE_KALENDER_2026_10 } from "./content/2026-10-28-book-mote-kalender";
import { ANSATTKORTET_V2_2026_10 } from "./content/2026-10-28-ansattkortet-v2";
import { ANSATTKORT_DRILLDOWN_2026_10 } from "./content/2026-10-29-ansattkort-drilldown";
import { KUNDE_PER_FAKTURA_2026_10 } from "./content/2026-10-29-kunde-per-faktura";
import { LUKK_MAANED_HULL_2026_11 } from "./content/2026-11-02-lukk-maaned-hull";
import { LUKK_MAANED_HELLIGDAGER_2026_11 } from "./content/2026-11-02-lukk-maaned-helligdager";
import { COLD_CALL_ARKET_2026_11 } from "./content/2026-11-02-cold-call-arket";
import { LEADS_AVVIST_2026_11 } from "./content/2026-11-03-leads-avvist";
import { LEADS_TAVLE_2026_11 } from "./content/2026-11-03-leads-tavle";
import { LEADS_BOOKERKO_2026_11 } from "./content/2026-11-03-leads-bookerko";

/**
 * Alle oppføringer, nyeste først. Ny release: legg til en fil i `content/` og
 * importer den her. `registry.test.ts` håndhever unike id-er, gyldige datoer og
 * at flagg-nøkler finnes i `FEATURE_FLAGS`.
 *
 * Lista bor i en EGEN fil, skilt fra filtreringslogikken i `registry.ts`, og det
 * er ikke tilfeldig: hjelp-temaet «Nytt i Revehiet» ankrer `registry.ts` fordi
 * det forklarer hvordan loggen filtreres på rolle og flagg. Lå lista i samme
 * fil, ville hver nye oppføring trippet hjelp-anker-gaten, selv om en ny
 * oppføring aldri kan få den forklaringen til å drifte. Nå fanger ankeret ekte
 * endringer i mekanismen, og ikke innholdet som legges til hver release.
 */
export const CHANGELOG_ENTRIES: readonly ChangelogEntry[] = [
  LEADLISTER_NYTT_LEAD_2026_10,
  LEAD_KONTAKTER_2026_10,
  TILBUDSARBEIDSROM_IDE_2026_10,
  TILBUDSARBEIDSROM_GRUNNLAG_2026_10,
  MANGLENDE_TIMER_VARSEL_2026_10,
  OPPDAG_RYDDET_2026_10,
  SIGNALER_LAERER_2026_10,
  SIGNALKORT_V2_2026_10,
  INTERNPROSJEKTER_OPPGAVER_2026_10,
  FUNKSJONSBRYTERE_RYDDET_2026_10,
  FAERRE_OPPDATERINGSVARSLER_2026_10,
  INNLOGGING_HJELP_2026_10,
  ALLE_KAN_ENDRE_KUNDE_2026_10,
  LOKASJONER_FRA_MOBIL_2026_10,
  LOKASJONER_ROTER_BILDER_2026_10,
  ALLE_KAN_OPPRETTE_KUNDE_2026_10,
  TILGANG_FRAVAER_OG_DISPLAY_2026_10,
  NETTSIDE_NY_KUNDE_2026_10,
  LOKASJONER_PA_PROSJEKTER_2026_10,
  LOKASJONER_KART_OG_SOL_2026_10,
  LOKASJONSBANK_2026_10,
  SIGNALER_DUBLETTER_2026_10,
  KUNDEKORT_GEEK_KRONER_2026_10,
  ENDRE_KUNDELOGO_2026_10,
  FRILANSERKORT_V2_2026_10,
  KUNDELOGOER_2026_10,
  UTSTYR_BELEGG_2026_10,
  UTSTYR_SERVICE_2026_10,
  UTSTYR_PRODUKTDATA_2026_10,
  UTSTYRSBOOKING_2026_10,
  UTSTYRSREGISTER_2026_10,
  FRILANSERBANKEN_2026_10,
  BILAG_LEVERANDOR_2026_10,
  FRILANS_PA_PROSJEKT_2026_10,
  NY_KUNDE_2026_10,
  FAKTURA_SENDING_2026_10,
  KONVERTERING_EST_KOSTNAD_2026_10,
  TAGGING_I_SVAR_2026_10,
  KUNDEKORT_WIREFRAME_2026_10,
  KUNDELISTE_V2_2026_10,
  KUNDEKORT_V3_2026_10,
  UX_BOLGEN_2026_09,
  DOKUMENTARKIV_2026_09,
  SLIDE_PREVIEW_2026_09,
  TILGANGSFIKSER_2026_10,
  SKJERMROLLE_2026_10,
  SMOKE_FIKSER_2026_10,
  RAPPORTFEIL_2026_10,
  DOKUMENTEDITOR_2026_10,
  EIERSKAP_2026_10,
  GRUPPER_2026_10,
  HJELP_SOK_2026_10,
  DOKUMENTARKIV_TRE_2026_10,
  BILDER_OG_VIDEO_2026_10,
  TIMEBANK_SALDO_2026_10,
  FULL_BREDDE_2026_10,
  HJELP_SKALL_2026_10,
  VERKTOYLINJE_2026_10,
  RBAC_REDIRECT_2026_10,
  DOKUMENTEDITOR_LEXICAL_2026_10,
  CHUNK_FEIL_2026_10,
  MARKOR_2026_10,
  DOKUMENTEDITOR_ARK_2026_10,
  DOKUMENTVERSJONER_2026_10,
  POWEROFFICE_KOBLING_2026_10,
  MELLOMFAKTURA_2026_10,
  UTRULLINGER_2026_10,
  VERSJONSVARSEL_2026_10,
  UTRULLING_LESBARHET_2026_10,
  BILDESTORRELSE_2026_10,
  CRM_KUNDEKORT_2026_10,
  CRM_FASE_2_SALGSMULIGHETER_2026_10,
  CRM_SIGNALER_2026_10,
  CRM_FASE_4_LEADS_OG_MOTER_2026_10,
  TILBUD_TIMEPRIS_2026_10,
  BUDSJETT_REKKEFOLGE_2026_10,
  DOKUMENTER_DRA_OG_SLIPP_2026_10,
  PROGNOSE_GRUNNLAG_2026_10,
  BILAGSFORDELING_TILGANG_2026_10,
  TM_BILAGSSTATUS_2026_10,
  BILAG_LINJE_FRA_GODKJENNING_2026_10,
  FAKTURAOVERSIKT_2026_10,
  FAKTURA_BETALINGSDATO_2026_10,
  KREDITERT_FAKTURA_2026_10,
  LEAD_POOL_2026_10,
  MALTALL_OPPRYDDING_2026_10,
  MALTALL_OPPFOLGING_2026_10,
  CHAT_ROM_2026_10,
  BOOK_MOTE_KALENDER_2026_10,
  ANSATTKORTET_V2_2026_10,
  ANSATTKORT_DRILLDOWN_2026_10,
  KUNDE_PER_FAKTURA_2026_10,
  LUKK_MAANED_HULL_2026_11,
  LUKK_MAANED_HELLIGDAGER_2026_11,
  COLD_CALL_ARKET_2026_11,
  LEADS_AVVIST_2026_11,
  LEADS_TAVLE_2026_11,
  LEADS_BOOKERKO_2026_11,
]
  .slice()
  .sort((a, b) => b.date.localeCompare(a.date));
